/**
 * Application bootstrap.
 *
 * The auth store is initialised BEFORE mounting so the first render already
 * knows whether there is a session. Mounting first would flash the login screen
 * for a signed-in user on every page refresh.
 */
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import { useAuthStore } from './stores/auth';
import './style.css';

async function bootstrap(): Promise<void> {
  const app = createApp(App);
  const pinia = createPinia();

  app.use(pinia);
  app.use(i18n);

  // Must run before `app.use(router)` installs the navigation guard, so the
  // guard's first evaluation sees a resolved session.
  await useAuthStore(pinia).initialise();

  app.use(router);
  app.mount('#app');
}

void bootstrap();
